/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon, {BaseProps} from "../Base"

const Copy = (props: BaseProps) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33325 11.3334H4.66658C3.74436 11.3334 2.95825 11.0084 2.30825 10.3584C1.65825 9.70835 1.33325 8.92224 1.33325 8.00002C1.33325 7.0778 1.65825 6.29169 2.30825 5.64169C2.95825 4.99169 3.74436 4.66669 4.66658 4.66669H7.33325V6.00002H4.66658C4.11103 6.00002 3.63881 6.19446 3.24992 6.58335C2.86103 6.97224 2.66659 7.44446 2.66659 8.00002C2.66659 8.55558 2.86103 9.0278 3.24992 9.41669C3.63881 9.80558 4.11103 10 4.66658 10H7.33325V11.3334ZM5.33325 8.66669V7.33335H10.6666V8.66669H5.33325ZM8.66658 11.3334V10H11.3333C11.8888 10 12.361 9.80558 12.7499 9.41669C13.1388 9.0278 13.3333 8.55558 13.3333 8.00002C13.3333 7.44446 13.1388 6.97224 12.7499 6.58335C12.361 6.19446 11.8888 6.00002 11.3333 6.00002H8.66658V4.66669H11.3333C12.2555 4.66669 13.0416 4.99169 13.6916 5.64169C14.3416 6.29169 14.6666 7.0778 14.6666 8.00002C14.6666 8.92224 14.3416 9.70835 13.6916 10.3584C13.0416 11.0084 12.2555 11.3334 11.3333 11.3334H8.66658Z"
      />
    </BaseSvgIcon>
  )
}

export default Copy
